module.exports = __webpack_public_path__ + "static/media/play-circle-no-shadow.4026e433.svg";